import { Link } from "react-router-dom";
import React from "react";

const SignupOnboardingWrapper = ({ children, actions }) => {
  return (
    <div className="min-h-full flex flex-col bg-white">
      <div className="sticky sm:fixed top-0 p-4 flex justify-center sm:justify-start z-50 bg-white border-b border-gray-200 sm:border-none">
        <Link to="/">
          <img alt="SupportMagic" src="/logo.png" className="h-8" />
        </Link>
      </div>

      <div className="flex-1 flex">{children}</div>

      {Boolean(actions) && (
        <div className="sticky bottom-0 p-4 flex justify-center sm:justify-start z-50 bg-white border-t border-gray-200">
          {actions}
        </div>
      )}
    </div>
  );
};

export default SignupOnboardingWrapper;
